module.exports = __webpack_public_path__ + "img/bg-top.a1af6768.png";